import { render, staticRenderFns } from "./Metrics.vue?vue&type=template&id=71474856&scoped=true"
import script from "./Metrics.vue?vue&type=script&lang=js"
export * from "./Metrics.vue?vue&type=script&lang=js"
import style0 from "./Metrics.vue?vue&type=style&index=0&id=71474856&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71474856",
  null
  
)

export default component.exports